import React from "react";
import "./Navbar.css";

const Navbar2 = ({ logo }) => {
  return (
    <nav
      className="navbar"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--clr-card-bg)",
        borderBottom: "1px solid var(--clr-border)",
      }}
    >
      <div className="navbar-brand">
        <img src={logo} alt="candorrx" className="logo" />
      </div>
    </nav>
  );
};

export default Navbar2;
